import { gql,useApolloClient  } from "@apollo/client";
import { useEffect,useState } from "react";

const GET_PAGE_BY_SLUG = gql`
  query GetPageBySlug($slug: String!) {
    page(slug: $slug) {
      id
      title
      slug
      content
      seoTitle
      seoDescription
      isPublished
      metadata {
        key
        value
      }
    }
  }
`;

const useCheckoutTermsPage = () => {
  const [pageId, setPageId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const client = useApolloClient();

  useEffect(() => {
    const fetchPageBySlug = async () => {
      try {
        setLoading(true);
        
        const result = await client.query({
          query: GET_PAGE_BY_SLUG,
          variables: {
            slug: "checkout-terms-and-conditions"
          }
        });

        if (result.data?.page) {
          setPageId(result.data.page.id);
          setError(null);
        } else {
          setError('Page not found');
        }
      } catch (err) {
        console.error('Error fetching checkout terms page:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    fetchPageBySlug();
  }, [client]);

  return { pageId, loading, error };
};

export default useCheckoutTermsPage;